var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowDiscountItem)?_c('div',{staticClass:"total-item-box"},_vm._l((_vm.getDiscountList),function(item,index){return _c('div',{key:index,staticClass:"total-item sp_text"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.deductTxt))]),_c('span',{staticClass:"price"},[_vm._v("-"+_vm._s(_vm._f("dollar")(item.deduct)))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }